'use strict';

var idbKeyval = require('idb-keyval');
var log = require('../../log/Log').channel('ImageDownloadService');
var sutl = require('../../sutl/Sutl');

/* global FileTransfer */

angular.module('inara').factory('ImageDownloadService', ImageDownloadService);

ImageDownloadService.$inject = ['KayleeService', '$q'];

function ImageDownloadService(KayleeService, $q) {
    var imageCaches = {};

    log.info('initializing');

    return {
        deleteImage: deleteImage,
        deleteImageCache: deleteImageCache,
        deleteImagesWithExclusions: deleteImagesWithExclusions,
        downloadImage: downloadImage,
        getImageCache: getImageCache,
        setImageCache: setImageCache
    };    

    function deleteImage(imageCacheName, name) {
        var idbKeyName = makeIdbKeyName(imageCacheName, name);
        return idbKeyval.get(idbKeyName)
        .then(function(url) {
            var filePath = url.split('?')[0];
            return $q(function(resolve, reject) {
                window.resolveLocalFileSystemURL(filePath, resolve, reject);
            })
            .then(function(fileEntry) {
                return $q(function(resolve, reject) {
                    fileEntry.remove(resolve, reject);
                });
            })
            .then(function() {
                return $q.resolve(filePath);
            })
            .catch(function(error) {
                log.warning('error removing ' + filePath + ' code : ' +
                    (error.code ? error.code : error));
                return $q.resolve();
            });
        })
        .then(function(filePath) {
            if (filePath) log.debug('deleted file: ' + filePath);
            return idbKeyval.del(idbKeyName);
        })
        .then(function() {
            log.debug('deleted ' + idbKeyName + ' from idb');
        })
        .catch(function(error) {
            log.warning('error deleting ' + idbKeyName + ' : ' +
                (error.message ? error.message : error));
        })
        .finally(function() {
            var cache = getImageCache(imageCacheName);
            delete cache[name];
            log.debug('removed ' + name + ' from ' + imageCacheName);
        });
    }

    function deleteImageCache(cacheName) {
        delete imageCaches[cacheName];
    }

    function deleteImagesWithExclusions(imageCacheName, imageNameExclusions) {
        if (process.env.appEnv === 'browser') return $q.resolve();
        if (typeof imageCacheName !== 'string') return $q.reject('image cache name required');

        // Image paths are stored in IDB with these key values:
        //   image.<imageCacheName>.<imageName>
        return idbKeyval.keys().then(function(keys) {
            var deleteImageNames = [];
            var keyPrefix = 'image.' + (imageCacheName ? imageCacheName + '.' : '');
            for (var i = 0; i < keys.length; i++) {
                if (keys[i].startsWith(keyPrefix)) {
                    var imageFileName = keys[i].substring(keyPrefix.length);
                    if (!imageNameExclusions.includes(imageFileName)) {
                        deleteImageNames.push(imageFileName);
                    }
                }
            }
            var deletePromises = [];
            for (i = 0; i < deleteImageNames.length; i++) {
                deletePromises.push(deleteImage(imageCacheName, deleteImageNames[i]));
            }
            return $q.all(deletePromises);
        });
    }

    function downloadImage(imageCache, storageObject, name) {
        var ext;
        var imageCacheName = null;

        if (typeof imageCache === 'string') {
            imageCacheName = imageCache;
            imageCache = getImageCache(imageCacheName);
            if (imageCache === null) return $q.reject('no image cache named: ' + imageCacheName);
        }

        if (process.env.appEnv === 'browser') {
            return storageObject.getDownloadURL()
            .then(function(downloadUrl) {
                imageCache[name].url = downloadUrl;
            })
            .catch(function(error) {
                log.error('error downloading image: ' + (error.message ? error.message : error));
            });
        }

        if (!KayleeService.isWorkingOnline()) {
            return idbKeyval.get(makeIdbKeyName(imageCacheName, name))
            .then(function(url) {
                log.info('offline cache ' + makeIdbKeyName(imageCacheName, name) + ': ' + url);
                imageCache[name].url = url;
            })
            .catch(function(error) {
                log.error('error getting image filename from IDB: ' +
                    (error.message ? error.message : error));
            });
        }

        imageCache[name].downloadPromise = storageObject.getMetadata()
        .then(function(fullMetadata) {
            switch (fullMetadata.contentType) {
                case 'image/gif': ext = '.gif'; break;
                case 'image/x-icon': ext = '.ico'; break;
                case 'image/jpeg': ext = '.jpg'; break;
                case 'image/png': ext = '.png'; break;
                case 'image/svg+xml': ext = '.svg'; break;
                case 'image/tiff': ext = '.tif'; break;
                case 'image/webp': ext = '.webp'; break;
                default:
                    log.warning('unhandled content type: ' + fullMetadata.contentType);
                    ext = '.img';
                    break;
            }
        })
        .then(function() {
            return storageObject.getDownloadURL();
        })
        .then(function(downloadUrl) {
            return $q(function(resolve, reject) {
                var fileTransfer = new FileTransfer();
                var dest = makeDownloadPath(imageCacheName, name, ext);
                fileTransfer.download(downloadUrl, dest, function(fileEntry) {
                    log.info('downloaded ' + makeIdbKeyName(imageCacheName, name) + ': ' + dest);
                    imageCache[name].url = dest +
                        (imageCache[name].key ? '?' + imageCache[name].key : '');
                    resolve();
                }, function(err) {
                    log.error('error downloading ' + imageCacheName + ', ' + name + ': ' + err.exception);
                    reject({ message: (imageCacheName ? imageCacheName + ', ' : '') +
                        name + ': ' + err.exception });
                });
            });
        })
        .then(function() {
            return idbKeyval.set(makeIdbKeyName(imageCacheName, name), imageCache[name].url);
        })
        .catch(function(error) {
            log.error('error downloading image: ' + (error.message ? error.message: error));
        });
        return imageCache[name].downloadPromise;
    }

    function getImageCache(cacheName) {
        return sutl.getNode(imageCaches, [cacheName]);
    }

    function makeDownloadPath(imageCacheName, name, ext) {
        return cordova.file.dataDirectory +
            (imageCacheName ? imageCacheName + '/' : '') + name + ext;
    }

    function makeIdbKeyName(imageCacheName, name) {
        return 'image.' + (imageCacheName ? imageCacheName + '.' : '') + name;
    }

    function setImageCache(cacheName, cache) {
        imageCaches[cacheName] = cache;
    }
}